module.exports = __webpack_public_path__ + "img/coupon.a8dfdfb0.png";